/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import TreatmentDeliveryPlan from './treatment-delivery-plan';
import TreatmentDeliveryPlanDetail from './treatment-delivery-plan-detail';
import TreatmentDeliveryPlanUpdate from './treatment-delivery-plan-update';
import TreatmentDeliveryPlanDeleteDialog from './treatment-delivery-plan-delete-dialog';

const TreatmentDeliveryPlanRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<TreatmentDeliveryPlan />} />
    <Route path="new" element={<TreatmentDeliveryPlanUpdate />} />
    <Route path=":id">
      <Route index element={<TreatmentDeliveryPlanDetail />} />
      <Route path="edit" element={<TreatmentDeliveryPlanUpdate />} />
      <Route path="delete" element={<TreatmentDeliveryPlanDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default TreatmentDeliveryPlanRoutes;
